<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>

    <v-dialog v-model="iosDialog">
      <v-card>
        <v-card-text>
          <v-icon
            @click="closeDialog"
            style="position:absolute; right:10px"
            class="black--text"
            large
          >mdi-close</v-icon>
          <div class="d-flex flex-column align-center justify-center">
            <div class="d-flex images mt-12">
              <img class="ml-5" src="@/assets/ocpn_grey.svg" alt />
              <img class="mx-5" src="@/assets/dn2me_icon.svg" alt />
              <img class="mr-5" src="@/assets/ocpn_grey.svg" alt />
            </div>
            <h2 class="font-weight-regular black--text text-center mt-10">Install DoctorNext2Me</h2>
            <p
              class="text-center mt-4"
              style="font-size:18px"
            >Install this application on your home screen for quick and easy access.</p>

            <div class="d-flex justify-center align-center mt-12">
              <p class="mb-0">1. Just tap</p>
              <img class="ml-2" src="@/assets/share.svg" alt />
            </div>

            <div class="d-flex justify-center align-center mt-2">
              <p class="mb-0">
                2. then
                <span class="font-weight-bold black--text">"Add to home Screen"</span>
              </p>
            </div>

            <v-checkbox
              class="mt-5"
              color="rgb(0,170,221)"
              v-model="dialog"
              label="Don't show this again"
            ></v-checkbox>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  name: "App",

  created() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });

    axios
      .get(`${process.env.VUE_APP_BASE_URL}/optionsList/doctorTypes/el`)
      .then(res => {
        //    this.doctorTypes = res.data

        this.$store.dispatch("doctorTypes", res.data);
      })
      .catch(err => {
        console.log(err);
      });
  },

  data: () => ({
    dialog: false
  }),

  methods: {
    closeDialog() {
      this.$store.dispatch("closeDialog", this.dialog);
    }
  },
  computed: {
    iosDialog() {
      return this.$store.state.iosDialog;
    }
  }
};
</script>

<style lang="scss">
* {
  font-family: "Roboto" sans-serif;
}

h1,
h2,
h3,
h4,
h5 {
  font-weight: 400;
}

#local {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 30vw;
  height: 25vh;
  z-index: 20;

  video {
    height: 100% !important;
    width: 100% !important;
    object-fit: cover !important;
    border-radius: 10px !important;
  }
}

#remote {
  position: absolute;
  top: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgb(0, 170, 221);
  display: flex;
  justify-content: center;
  align-items: center;

  video {
    height: 100% !important;
    width: 100% !important;
    object-fit: cover !important;
  }
}

#dialogRelative {
  position: relative !important;
}
</style>
